/**
 * @description Namespace containing constants for all game type IDs in the system
 * @remarks These IDs correspond to the primary keys in the game_types table
 */
export namespace GameTypeId {
  /** ID for Slots game type */
  export const Slots = 1n;
  /** ID for Scratch game type */
  export const Scratch = 2n;
  /** ID for Roulette game type */
  export const Roulette = 3n;
  /** ID for Card game type */
  export const Card = 4n;
  /** ID for Casual game type */
  export const Casual = 5n;
  /** ID for Lottery game type */
  export const Lottery = 6n;
  /** ID for Poker game type */
  export const Poker = 7n;
  /** ID for Craps game type */
  export const Craps = 8n;
  /** ID for Crash game type */
  export const Crash = 9n;
  /** ID for Fishing game type */
  export const Fishing = 10n;
  /** ID for Mines game type */
  export const Mines = 11n;
  /** ID for Tower game type */
  export const Tower = 12n;
  /** ID for Mission Uncrossable game type */
  export const MissionUncrossable = 13n;
  /** ID for Video Poker game type */
  export const VideoPoker = 14n;
  /** ID for Virtual Sports game type */
  export const VirtualSports = 15n;
}

/**
 * @description Type representing any valid game type ID value
 * @example const gameTypeId: GameTypeIdType = GameTypeId.Slots;
 */
export type GameTypeIdType = (typeof GameTypeId)[keyof typeof GameTypeId];
